
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'ホーム', path: '/' },
    { name: '理念', path: '/philosophy' },
    { name: '会社概要', path: '/company' },
    { name: 'サービス', path: '/services' },
    { name: 'プロジェクト', path: '/projects' },
    { name: 'ニュース', path: '/news' },
    { name: 'お問い合わせ', path: '/contact' },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#F6F3EB]/95 backdrop-blur-sm shadow-sm' : 'bg-[#F6F3EB]/90'
      }`}
    >
      <nav className="px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/721199a06948bc0907bde1e591c4b4e9/c0c614a55c746105676b5a18f8abb441.png"
              alt="2b LLC"
              className="h-14 object-contain"
            />
          </Link>
          
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-[#4A4A48] hover:text-[#AFC5C2] transition-colors duration-300 font-medium whitespace-nowrap hover:underline hover:decoration-[0.5px] ${
                  location.pathname === item.path ? 'text-[#AFC5C2]' : ''
                }`}
                style={{ fontFamily: 'Montserrat, "Zen Kaku Gothic New", sans-serif' }}
              >
                {item.name}
              </Link>
            ))}
          </div>

          <div className="md:hidden">
            <button 
              onClick={toggleMobileMenu}
              className="text-[#4A4A48] hover:text-[#AFC5C2] transition-colors cursor-pointer"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-[#AFC5C2]/20">
            <div className="flex flex-col space-y-3 pt-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={closeMobileMenu}
                  className={`text-[#4A4A48] hover:text-[#AFC5C2] transition-colors duration-300 font-medium py-2 px-2 rounded-md hover:bg-[#AFC5C2]/10 ${
                    location.pathname === item.path ? 'text-[#AFC5C2] bg-[#AFC5C2]/10' : ''
                  }`}
                  style={{ fontFamily: 'Montserrat, "Zen Kaku Gothic New", sans-serif' }}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
